/**
 * File: AIDisclaimer.tsx
 * Description: Reusable AI disclaimer component with information icon
 * Author: System
 * Created: 2026-01-05
 * Last Modified: 2026-01-05
 */

import { InformationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface AIDisclaimerProps {
  className?: string;
}

/**
 * AIDisclaimer - Reusable component for showing AI-generated content disclaimer
 */
export const AIDisclaimer: React.FC<AIDisclaimerProps> = ({ 
  className = '',
}) => {
  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg p-3 ${className}`}>
      <div className="flex items-center gap-2 text-blue-800">
        <InformationCircleIcon className="w-4 h-4 flex-shrink-0" />
        <span className="text-sm">
          AI-generated content may be incorrect. Check important info.
        </span>
      </div>
    </div>
  );
};
